import React from "react"
import { FaEnvelope } from "react-icons/fa"
import { ProfileType } from "../../types"

const Header = ({ initials }) => (
  <header className="flex justify-between p-4 lg:px-8 mb-16">
    {/* <span className="inline-flex w-14 h-14 lg:mt-4 font-header font-bold text-xl justify-center items-center text-center text-front border-2 border-solid border-front rounded-full">
      {initials}
    </span> */}
    <a
      className="sticky flex w-14 h-14 font-header font-semibold px-2 bg-lead rounded-full text-lead-text justify-center items-center leading-tight lg:w-auto lg:h-auto lg:px-6 lg:py-2 lg:rounded-lg lg:self-start lg:mt-4 hover:opacity-75 transition-opacity duration-150"
      href="#contact"
    >
      <FaEnvelope className="inline-block h-6 w-6 lg:hidden" />
      <span className="hidden lg:block">Kontakt</span>
    </a>
    <style type="text/css">{`
    .bg-no-repeat .w-full img {
      border: 1px dotted gray;
    }
    .bg-lead {
      background-color: #B6B5D8 !important;
    }
    .border-skill-1, .border-skill-2, .border-skill-3 {
      border-color: #B6B5D8 !important;
    }
    .text-skill-1, .text-skill-2, .text-skill-3 {
      color: #B6B5D8 !important;
    }
    .bg-back {
      background-color: white !important;
    }
    form {
      background-color: #B6B5D8;
    }
    .history-entry:first-child .dot {
      background-color: #B6B5D8;
    }
    `}</style>
  </header>
)

Header.propTypes = {
  initials: ProfileType.initials,
}

export default Header